module.exports = __webpack_public_path__ + "media/images/sales/early/btn-cta-5-7b252a72f853d7c1f8a8ee9e772a640e.svg";